<template>
  <div>
    <h1 class="page-title text-left">Adulticide</h1>
    <div class="panel">
      <div class="panel-heading">
        <h3 class="panel-title">
          Details
          <router-link :to="{ name: 'data-adulticide' }" class="pull-right ml-10"><i class="fa fa-list"></i></router-link>
          <i class="fa fa-pencil pointer pull-right" v-on:click="showEdit()"></i>
        </h3>
      </div>
      <div class="panel-body">
        <dl class="dl-horizontal">

          <dt>Type</dt>
          <dd>
            <span v-if="form.data.contractId">Truck</span>
            <span v-if="form.data.siteId">Barrier</span>
          </dd>

          <div v-if="form.data.siteId">
            <dt>Site</dt>
            <dd>{{ siteName(form.data.siteId) }}</dd>
          </div>

          <div v-if="form.data.contractId">
            <dt>Contract</dt>
            <dd>{{ contractName(form.data.contractId) }}</dd>
          </div>

          <dt>Coordinates</dt>
          <dd class="pointer" v-on:click="showMap(form.data.coordinates)">
            <span v-if="form.data.coordinates"><i class="fa fa-map"></i> {{ form.data.coordinates.length }} points</span>
          </dd>

          <dt>Application Date</dt>
          <dd>{{ form.data.applicationDate | date }}</dd>

          <dt>Zone</dt>
          <dd>{{ zoneName(form.data.zoneId) }}</dd>

          <dt>Municipality</dt>
          <dd>{{ municipalityName(form.data.municipalityId) }}</dd>

          <dt>County</dt>
          <dd>{{ countyName(form.data.countyId) }}</dd>

          <dt>Equipment Used</dt>
          <dd>{{ aEquipmentName(form.data.aequipId) }}</dd>

          <dt>Truck</dt>
          <dd>{{ truckName(form.data.truckId) }}</dd>

          <dt>Applicator</dt>
          <dd>{{ applicatorName(form.data.applicatorId) }}</dd>

          <dt>License</dt>
          <dd>{{ form.data.license }}</dd>

          <dt>Chemical</dt>
          <dd>{{ achemicalName(form.data.achemicalId) }}</dd>

          <dt>EPA Number</dt>
          <dd>{{ form.data.epaRegno }}</dd>

          <dt>Mix Ratio</dt>
          <dd>{{ mixRatio(form.data.mixRatioId) }}</dd>

          <dt>Appl. Rate</dt>
          <dd>{{ adultAppRateName(form.data.adultapprateId) }}</dd>

          <dt>Flow Rate</dt>
          <dd>{{ form.data.flowRate }}</dd>

          <dt>Temperature</dt>
          <dd>{{ form.data.temperature }}</dd>

          <dt>Wind Speed</dt>
          <dd>{{ form.data.windSpeed }}</dd>

          <dt>Wind Direction</dt>
          <dd>{{ windDirection(form.data.windDirectionId) }}</dd>

          <dt>Start Time</dt>
          <dd>{{ form.data.startTime | time }}</dd>

          <dt>End Time</dt>
          <dd>{{ form.data.endTime | time }}</dd>

          <dt>Odometer Start</dt>
          <dd>{{ form.data.odometerStart }}</dd>

          <dt>Odometer End</dt>
          <dd>{{ form.data.odometerEnd }}</dd>

          <dt>Sprayer Start</dt>
          <dd>{{ form.data.sprayerStart }}</dd>

          <dt>Sprayer End</dt>
          <dd>{{ form.data.sprayerEnd }}</dd>

          <dt>Trip Miles</dt>
          <dd>{{ form.data.tripMiles }}</dd>

          <dt>Spray Miles</dt>
          <dd>{{ form.data.sprayMiles }}</dd>

          <dt>Spray Acres</dt>
          <dd>{{ form.data.sprayAcres }}</dd>

          <dt>Ounces Sprayed</dt>
          <dd>{{ form.data.ouncesSprayed }}</dd>

          <dt>Visual Monitoring</dt>
          <dd><i class="fa" :class="{ 'fa-check-square-o': form.data.vizualMonitorPerformed, 'fa-square-o': !form.data.vizualMonitorPerformed}"></i></dd>

          <dt>Adverse Incident</dt>
          <dd><i class="fa" :class="{ 'fa-check-square-o': form.data.adverseIncident, 'fa-square-o': !form.data.adverseIncident}"></i></dd>

          <dt>Water of US</dt>
          <dd><i class="fa" :class="{ 'fa-check-square-o': form.data.waterOfUs, 'fa-square-o': !form.data.waterOfUs}"></i></dd>

          <dt v-if="form.data.serviceRequestId">Service Request</dt>
          <dd v-if="form.data.serviceRequestId"><router-link :to="{ name: 'data-service-request-details', params: {id: form.data.serviceRequestId} }">view details</router-link></dd>

          <dt>Work Status</dt>
          <dd>{{ form.data.workStatus }}</dd>

        </dl>
      </div>
    </div>

    <site-form :form="form" ></site-form>
    <google-map ref="gmap"></google-map>


  </div>
</template>

<script>
  import AdulticideService from '@/services/AdulticideService';
  import Form from '@/utils/form';
  import loader from '@/utils/loader';
  import siteForm from '@/components/forms/adulticide';

  import store from '@/store';
  import googleMap from '@/components/googleMap';

  export default {
    name: 'adulticide_details',

    components: {
      siteForm,
      googleMap
  },

    props: ['id'],

    data() {
      return {
        form: new Form(
          AdulticideService,
          {
          })
      }
    },

    methods: {
      siteName(id) {
        return this.$store.getters.siteNameById(id);
      },
      contractName(id) {
        return this.$store.getters.contractNameById(id);
      },
      countyName(id) {
        return this.$store.getters.countyNameById(id);
      },
      municipalityName(id) {
        return this.$store.getters.municipalityNameById(id);
      },
      stateName(id) {
        return this.$store.getters.stateNameById(id);
      },
      achemicalName(id) {
        return this.$store.getters.achemicalNameById(id);
      },
      mixRatio(id) {
        return this.$store.getters.mixRatioNameById(id);
      },
      windDirection(id) {
        return this.$store.getters.windDirectionNameById(id);
      },
      applicatorName(id) {
        return this.$store.getters.applicatorNameById(id);
      },
      aEquipmentName(id) {
        return this.$store.getters.aEquipementNameById(id);
      },
      vizualMonitorName(id) {
        return this.$store.getters.vizualMonitorNameById(id);
      },
      adultAppRateName(id) {
        return this.$store.getters.adultAppRatesNameById(id);
      },
      zoneName(id) {
        return this.$store.getters.zoneNameById(id);
      },
      truckName(id) {
        return this.$store.getters.trucksNameById(id);
      },
      showMap(coordinates) {
        this.$refs.gmap.showMap(coordinates);
      },
      showEdit() {
        if (this.form.data.contractId) {
          this.form.data.truck = true;
          this.form.data.barrier = false;
          this.form.showEdit({id: this.form.data.id, title: 'Edit Truck ULV Data', list: true});
        } else {
          this.form.data.truck = false;
          this.form.data.barrier = true;
          this.form.showEdit({id: this.form.data.id, title: 'Edit Adulticide Data', list: true});
          this.form.siteSearch.term = this.siteName(this.form.data.siteId);
          this.form.onSiteSearch('siteId');
        }
      }
    },

    mounted() {

      loader.lookups()
        .then(() => {
          this.form.getDetails(this.id);
        });
    }

  }
</script>

<style lang="scss">

</style>
